import React, {useEffect, useRef} from 'react'
import {Link} from 'react-router-dom'
import {promosForDisplay} from '../timedPromos'
import './TimedPromos.scss'

// Home page advert listing the shop's time-window deals (src/timedPromos.js).
// Always shown, whether or not a deal is on right now.
export function TimedPromoHomeBanner ({shopId}) {
  const promos = promosForDisplay(shopId)
  if (!promos.length) { return null }
  return (
    <section className="timed-promo-banner" aria-label="daily deals">
      <h2 className="timed-promo-banner__title">Daily Deals</h2>
      <ul className="timed-promo-banner__list">
        {promos.map((promo) => (
          <li key={promo.id} className="timed-promo-banner__item">
            <p className="timed-promo-banner__headline">{promo.headline}</p>
            {promo.detail && <p className="timed-promo-banner__detail">{promo.detail}</p>}
            <p className="timed-promo-banner__time">{promo.timeText} daily</p>
          </li>
        ))}
      </ul>
      <Link to={{pathname: "/order", state: {startAtTop: true}}} className="timed-promo-banner__cta">Order Now</Link>
    </section>
  )
}

// Strip above the ordering menu while a whole-menu promo (happy hour) is on.
export function TimedPromoBar ({text}) {
  if (!text) { return null }
  return <p className="timed-promo-bar" role="status">{text}</p>
}

// Shown when checkout re-priced the cart because a promo window closed or
// opened for the order time. Closing it leaves the customer on the updated cart.
export function PriceChangedDialog ({info, onClose}) {
  const buttonRef = useRef(null)
  useEffect(() => {
    if (!info) { return }
    try { buttonRef.current && buttonRef.current.focus() } catch (e) {}
    const onKey = (e) => { if (e.key === 'Escape') { onClose() } }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [info, onClose])
  if (!info) { return null }
  return (
    <div className="price-changed-dialog__backdrop" onClick={onClose}>
      <div
        className="price-changed-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="price-changed-dialog-title"
        aria-describedby="price-changed-dialog-body"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="price-changed-dialog-title" className="price-changed-dialog__title">Your prices changed</h2>
        <div id="price-changed-dialog-body">
          {info.reasons.map((reason) => <p key={reason}>{reason}</p>)}
          <p className="price-changed-dialog__totals">
            Total: <s>${info.before.toFixed(2)}</s> <strong>${info.after.toFixed(2)}</strong>
          </p>
          <p>Your order was not placed. Please review your cart and place your order again.</p>
        </div>
        <button ref={buttonRef} type="button" className="price-changed-dialog__button" onClick={onClose}>Review cart</button>
      </div>
    </div>
  )
}
